import { render, staticRenderFns } from "./info-screening-eye-history.vue?vue&type=template&id=620d859e&"
import script from "./info-screening-eye-history.vue?vue&type=script&lang=js&"
export * from "./info-screening-eye-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports